import { Card, CardContent } from "@/components/ui/card";
import type { DiveDetail } from "@/lib/database";

interface DiveStatsProps {
  dive: DiveDetail;
}

interface StatCardProps {
  label: string;
  value: string | number;
  unit?: string;
}

function StatCard({ label, value, unit }: StatCardProps) {
  return (
    <Card>
      <CardContent className="px-3.5 py-2.5 sm:px-4 sm:py-3">
        <div className="text-xs sm:text-sm text-muted-foreground">{label}</div>
        <div className="text-xl sm:text-2xl font-bold">
          {value}
          {unit && <span className="text-xs sm:text-sm font-normal ml-1">{unit}</span>}
        </div>
      </CardContent>
    </Card>
  );
}

export function DiveStats({ dive }: DiveStatsProps) {
  const formatDuration = (minutes: number) => {
    const mins = Math.floor(minutes);
    const secs = Math.round((minutes - mins) * 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3">
      <StatCard
        label="Max Depth"
        value={dive.maxDepthFeet}
        unit="ft"
      />
      <StatCard
        label="Avg Depth"
        value={dive.calculatedStats.avgDepthFeet.toFixed(1)}
        unit="ft"
      />
      <StatCard
        label="Duration"
        value={formatDuration(dive.durationMinutes)}
        unit="min"
      />
      <StatCard
        label="Temperature"
        value={`${dive.calculatedStats.minTempF}-${dive.calculatedStats.maxTempF}`}
        unit="°F"
      />
    </div>
  );
}
